<template>
    <button class="u-reset contact-overlay-trigger" :class="rootClasses" @click="onClick">
        <slot/>
    </button>
</template>

<script>

    const TYPE_BUTTON = 'button';
    const TYPE_LINK = 'link';

    import { mapActions } from 'vuex';

    export default {
        props: {
            src: {
                type: String,
                required: true,
            },

            hasIcon: {
                type: Boolean,
                default: false,
            },

            type: {
                type: String,
                default: TYPE_LINK,
            },
        },

        data() {
            return {
                overlayId: null,
            };
        },

        computed: {
            rootClasses() {
                let classes = [];
                if (this.type === TYPE_BUTTON) {
                    classes = [
                        'btn',
                        'btn__has-grid',
                        'btn__medium',
                        'btn__primary-green',
                    ];
                } else if (this.type === TYPE_LINK) {
                    classes = [
                        'link',
                        'link__no-underline',
                        this.hasIcon ? 'link__icon' : 'link__base',
                    ];
                }
                return classes;
            },
        },

        methods: {
            ...mapActions('overlay', ['openOverlay', 'registerOverlay', 'unregisterOverlay']),

            onClick() {
                this.openOverlay({ id: this.overlayId, trackingId: 'Contact' });
            },
        },

        mounted() {
            this.registerOverlay({
                component: 'dyn-contact-overlay',
                url: this.src,
                backgroundClosable: true,
            })
                .then((id) => {
                    this.overlayId = id;
            });
        },
    };
</script>
